import { DateTime } from 'luxon';
import { defaultChoicePickerState } from 'shell/components/shared/choice-date/constants';
import { CODE_STATE_ITALIAN } from 'shell/constants/code-state-italian';
import { ModelEventoDTO, SubjectAnpr } from 'shell/models/act-category-list';
import { SubscriptionAccordionGenerality } from 'subscription/view-models/common-interface-subscription';

export const transformGenerality = (
  subjectAnpr: SubjectAnpr,
  modelEventoDTO?: ModelEventoDTO
): SubscriptionAccordionGenerality => {
  const isForeign = subjectAnpr.idStatoNascita !== CODE_STATE_ITALIAN;

  // Split sul nome per 3727
  const formattedName = subjectAnpr.nome ? subjectAnpr.nome.split(',')[0] : '';

  return {
    fiscalCode: subjectAnpr.codiceFiscale || '',
    surname: subjectAnpr.cognome || '',
    name: formattedName,
    gender: subjectAnpr.sesso || '',
    birthDate: subjectAnpr.dataNascita ? DateTime.fromISO(subjectAnpr.dataNascita) : null,
    birthChoiceDate: subjectAnpr.dataNascita ? defaultChoicePickerState : undefined,
    aire: subjectAnpr.idComuneAIRE ? 'S' : 'N',
    deathPerson: modelEventoDTO?.datiDiNascita?.natoMorto === 'SI',
    isForeign,
    italian: isForeign
      ? undefined
      : {
          municipality: {
            description: subjectAnpr.nomeComuneNascita || '',
            province: subjectAnpr.siglaProvinciaNascita || '',
            code: subjectAnpr.idComuneNascita
              ? Number.parseInt(subjectAnpr.idComuneNascita.toString(), 10)
              : undefined,
            id: subjectAnpr.idComuneNascita || '',
            idProvince: subjectAnpr.idProvinciaNascita
              ? Number.parseInt(subjectAnpr.idProvinciaNascita.toString(), 10)
              : undefined,
            provinceCode: subjectAnpr.idProvinciaNascita || '',
          },
        },
    foreign: isForeign
      ? {
          state: {
            id: subjectAnpr.idStatoNascita || '',
            value: subjectAnpr.nomeStatoNascita || '',
          },
          municipality: subjectAnpr.idComuneNascita
            ? {
                description: subjectAnpr.nomeComuneNascita || '',
                province:
                  subjectAnpr.siglaProvinciaNascita || subjectAnpr.localitaEsteraNascita || '',
                id: subjectAnpr.idComuneNascita || '',
                idProvince: subjectAnpr.idProvinciaNascita
                  ? Number.parseInt(subjectAnpr.idProvinciaNascita.toString(), 10)
                  : undefined,
                provinceCode: subjectAnpr.idProvinciaNascita || '',
              }
            : undefined,
        }
      : undefined,
  };
};
